import { Tab, Tabs } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchPatient } from '../../../store/patientsSlice';
import { AppDispatch, RootState } from '../../../store/store';
import DashboardGeneral from './DashboardGeneral';
import DashboardQuestionnaire from './DashboardQuestionnaire';
import PatientSidebar from './PatientSidebar';

/**
 * Patient Dashboard
 * This is a container component that displays the patient dashboard.
 * However it is based on fake values coming from harcoded data (see patient_data*.json)
 */

export const PatientDashboard: React.FC = () => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const dispatch: AppDispatch = useDispatch();
  const tabs = ['general', 'sleep', 'activity', 'mood'];
  const currentTab = tabs.includes(tab || '') ? tab : tabs[0];

  const periodTabs = ['week', '4weeks', '3month', 'year'];
  const currentPeriodTab = periodTabs[1];

  const { patientEdited, loading } = useSelector((state: RootState) => state.patients);

  const handleTabChange = (newTab: string) => {
    if (id) {
      navigate(`/patient/${id}/dashboard/${newTab}`);
    }
  };

  useEffect(() => {
    if (id) {
      void dispatch(fetchPatient({ id: id }));
    }
  }, [dispatch, id]);

  const navigate = useNavigate();

  if (loading || !patientEdited) {
    return <div>Loading...</div>;
  }

  return (
    <Grid container spacing={3} sx={{ bgcolor: '#fafafa' }}>
      {/* Left Sidebar */}
      <Grid size={2} sx={{ bgcolor: 'background.paper' }}>
        <PatientSidebar patient={patientEdited} />
      </Grid>
      {/* Sidebar content */}

      {/* Main content area */}
      <Grid container size={10} sx={{ bgcolor: 'background.paper', p: 4 }}>
        <Grid size={6}>
          {/* Tabs */}
          <Tabs
            onChange={(_event, newValue: string) => {
              handleTabChange(newValue);
            }}
            value={currentTab}
          >
            <Tab label="Général" value={tabs[0]} />
            <Tab label="Sommeil" value={tabs[1]} />
            <Tab label="Activité Physique" value={tabs[2]} />
            <Tab label="Humeur" value={tabs[3]} />
          </Tabs>
        </Grid>
        <Grid size={6}>
          <Tabs value={currentPeriodTab}>
            <Tab label="7 jours" value={periodTabs[0]} />
            <Tab label="4 semaines" value={periodTabs[1]} />
            <Tab label="3 mois" value={periodTabs[2]} />
            <Tab label="12 mois" value={periodTabs[3]} />
          </Tabs>
        </Grid>

        {/* Page Content (children) */}
        <Grid size={12}>
          {currentTab === tabs[0] && <DashboardGeneral />}
          {currentTab === tabs[3] && <DashboardQuestionnaire />}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PatientDashboard;
